// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { immutableZkEvm as _immutableZkEvm } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the immutableZkEvm chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 13371
 * Chain Name: Immutable zkEVM
 * Default Block Explorer: https://explorer.immutable.com
 * Default RPC URL: https://rpc.immutable.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { immutableZkEvm } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: immutableZkEvm,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const immutableZkEvm = createCommon({
	..._immutableZkEvm,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
